"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadingPromptWithData = void 0;
var react_1 = __importDefault(require("react"));
var mappings_1 = require("../../../../shared/api/mappings");
var core_1 = require("../../../../shared/core");
var kapi_meter_reads_1 = require("../../../kapi-meter-reads");
var utils_1 = require("../../utils");
var ReadingPrompt_1 = require("./ReadingPrompt");
var ReadingPromptWithDataLegacy_1 = require("./legacy/ReadingPromptWithDataLegacy");
//Usage component is not designed for complex setups, so just find most recent read across all trad supplies
var getLatestTradActualReading = function (supplies) {
    var _a;
    return (0, kapi_meter_reads_1.getLatestActualReading)((_a = supplies === null || supplies === void 0 ? void 0 : supplies.filter(function (supply) { return !supply.states.isSmart; }).flatMap(function (supply) { return supply.readings; })) !== null && _a !== void 0 ? _a : []);
};
var ReadingPromptWithData = function (_a) {
    var accountId = _a.accountId, fuel = _a.fuel, supplyInfo = _a.supplyInfo;
    var _b = core_1.configService.getConfig(), retailer = _b.retailer, kapi = _b.kapi;
    var kapiEnabled = retailer.region === 'UK' ? kapi && (kapi === null || kapi === void 0 ? void 0 : kapi.usageReads) : true;
    var readsData = (0, mappings_1.useMeterReads)(accountId, !kapiEnabled).data;
    if (!(0, utils_1.hasTradMeter)(supplyInfo)) {
        return null;
    }
    if (kapiEnabled) {
        return readsData ? (react_1.default.createElement(ReadingPrompt_1.ReadingPrompt, { lastActualElecRead: getLatestTradActualReading(readsData === null || readsData === void 0 ? void 0 : readsData.electricity), lastActualGasRead: getLatestTradActualReading(readsData === null || readsData === void 0 ? void 0 : readsData.gas), fuel: fuel })) : null;
    }
    else {
        return (react_1.default.createElement(ReadingPromptWithDataLegacy_1.ReadingPromptWithDataLegacy, { accountId: accountId, fuel: fuel, supplyInfo: supplyInfo }));
    }
};
exports.ReadingPromptWithData = ReadingPromptWithData;
